

import React, { useEffect, useRef, useState, useMemo } from 'react';
import { X, MessageSquare, SendHorizonal, MoreVertical, MoveVertical, ChevronsUpDown } from 'lucide-react';
import './ChatbotWidget.css';
import {
  useChatMessages,
  useChatInteract,
  useChatData
} from '@chainlit/react-client';
import ConfirmationPopup from './ConfirmationPopup';
import { CollapseIcon, ExpandIcon } from './components/icons';

const WebethicsLogo = () => {
  return (
    <svg
      width={96}
      height={24}
      viewBox="0 0 96 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.589 11.9247L14.8596 0.815223H17.4038L13.9981 15.5736H11.545L8.73738 4.79922L5.86874 15.574H3.40577L0 0.815223H2.54428L4.83512 11.904L7.65272 0.815223H9.80215L12.5895 11.9247H12.589ZM23.5567 15.7764C21.9998 15.7764 20.7305 15.2847 19.7608 14.306C18.7912 13.3273 18.3064 12.0138 18.3064 10.3782V10.0742C18.3064 8.98 18.5175 8.0013 18.94 7.1398C19.3625 6.2783 19.9555 5.60752 20.7188 5.12791C21.4821 4.64829 22.3337 4.40826 23.273 4.40826C24.7664 4.40826 25.9198 4.88485 26.7346 5.8376C27.5494 6.79036 27.9559 8.13839 27.9559 9.88215V10.8756H20.7897C20.8641 11.7812 21.166 12.4974 21.6971 13.025C22.2281 13.5526 22.895 13.8155 23.6994 13.8155C24.8239 13.8155 25.7468 13.3593 26.4565 12.4472L27.7842 13.7143C27.3448 14.37 26.7592 14.882 26.0257 15.2397C25.2923 15.5974 24.4688 15.7812 23.5571 15.7812L23.5567 15.7764ZM23.2626 6.38037C22.5867 6.38037 22.0413 6.61693 21.6257 7.08963C21.2101 7.56233 20.945 8.22143 20.8299 9.06606H25.5223V8.88355C25.4683 8.05925 25.2486 7.43562 24.8637 7.01351C24.4788 6.59142 23.9442 6.37993 23.2618 6.37993L23.2626 6.38037ZM39.491 10.1966C39.491 11.8997 39.1104 13.2542 38.3505 14.261C37.5907 15.2678 36.5445 15.7755 35.2133 15.7755C33.9289 15.7755 32.9298 15.3128 32.2128 14.3916L32.0917 15.5775H29.8618V0.0082171H32.3248V5.65553C33.0341 4.81739 33.9907 4.39875 35.1934 4.39875C36.5315 4.39875 37.582 4.89523 38.3505 5.88864C39.1191 6.88204 39.4957 8.27073 39.4957 10.0547V10.1974L39.491 10.1966ZM37.0276 9.98378C37.0276 8.79446 36.8183 7.90226 36.3992 7.3076C35.9801 6.71294 35.3721 6.4154 34.5741 6.4154C33.5059 6.4154 32.7564 6.88161 32.3239 7.81403V12.3347C32.7633 13.2875 33.5202 13.7641 34.5945 13.7641C35.3643 13.7641 35.9594 13.4769 36.3784 12.9026C36.7975 12.3283 37.0142 11.4598 37.0271 10.2978V9.98378H37.0276ZM46.3834 15.7721C44.8265 15.7721 43.5572 15.2804 42.5875 14.3017C41.6179 13.323 41.1331 12.0095 41.1331 10.3739V10.0698C41.1331 8.97567 41.3442 7.99697 41.7667 7.13547C42.1892 6.27398 42.7822 5.6032 43.5455 5.12358C44.3088 4.64396 45.1604 4.40394 46.0997 4.40394C47.5931 4.40394 48.7465 4.88053 49.5613 5.83328C50.3761 6.78603 50.7826 8.13407 50.7826 9.87782V10.8712H43.6164C43.6908 11.7768 43.9927 12.493 44.5237 13.0207C45.0548 13.5483 45.7217 13.8112 46.5261 13.8112C47.6506 13.8112 48.5735 13.355 49.2832 12.4429L50.6109 13.71C50.1715 14.3657 49.5859 14.8777 48.8524 15.2354C48.1189 15.593 47.2955 15.7768 46.3838 15.7768L46.3834 15.7721ZM46.0893 6.37604C45.4134 6.37604 44.868 6.61261 44.4524 7.08531C44.0368 7.55801 43.7717 8.2171 43.6566 9.06174H48.3499V8.87923C48.2958 8.05492 48.0761 7.43129 47.6912 7.00919C47.3063 6.58709 46.7718 6.37561 46.0893 6.37561V6.37604ZM55.7799 1.93621V4.60201H57.7161V6.42707H55.7799V12.5536C55.7799 12.9731 55.8664 13.2749 56.0281 13.4609C56.1899 13.6469 56.4892 13.7399 56.9147 13.7399C57.1984 13.7399 57.4856 13.7061 57.7762 13.6387V15.5442C57.2153 15.6999 56.6747 15.7777 56.1544 15.7777C54.2623 15.7777 53.3161 14.7337 53.3161 12.6457V6.43097H51.5118V4.6059H53.3161V1.93621H55.7795H55.7799ZM62.024 5.80257C62.8284 4.87015 63.8404 4.40394 65.0752 4.40394C67.4132 4.40394 68.599 5.73857 68.6332 8.40783V15.574H66.1702V8.49865C66.1702 7.74181 66.0059 7.2064 65.6785 6.89199C65.3511 6.57758 64.8697 6.41626 64.234 6.41626C63.2479 6.41626 62.511 6.85566 62.0284 7.73403V15.5693H59.5654V0H62.0284V5.80257H62.024ZM71.126 1.74808C71.126 1.3675 71.2458 1.05049 71.4858 0.798357C71.7258 0.546221 72.0688 0.42037 72.5151 0.42037C72.9614 0.42037 73.3057 0.546654 73.5531 0.798357C73.8004 1.05006 73.9181 1.36707 73.9181 1.74808C73.9181 2.12261 73.797 2.43443 73.5531 2.68224C73.3091 2.93005 72.9649 3.05503 72.5151 3.05503C72.0653 3.05503 71.7263 2.93091 71.4858 2.68224C71.2454 2.43356 71.126 2.12218 71.126 1.74808ZM73.7412 15.5736H71.2782V4.6059H73.7412V15.5736ZM80.9277 13.8099C81.5427 13.8099 82.053 13.6309 82.4587 13.2728C82.8643 12.9147 83.0806 12.4718 83.1074 11.9451H85.4285C85.4013 12.6275 85.1885 13.2641 84.7897 13.8558C84.391 14.4474 83.8504 14.9153 83.1679 15.2596C82.4855 15.6038 81.7494 15.7764 80.9623 15.7764C79.4283 15.7764 78.2117 15.2799 77.313 14.2865C76.4143 13.2931 75.965 11.9209 75.965 10.171V9.91761C75.965 8.24824 76.4105 6.91188 77.3031 5.90853C78.1957 4.90518 79.4114 4.4035 80.9524 4.4035C82.2567 4.4035 83.3193 4.78408 84.1397 5.54395C84.9601 6.30382 85.3917 7.30241 85.432 8.5393H83.1109C83.0836 7.91091 82.8687 7.3941 82.4673 6.98843C82.066 6.58277 81.5535 6.38037 80.932 6.38037C80.1345 6.38037 79.5195 6.66926 79.0871 7.24705C78.6546 7.82485 78.4349 8.70148 78.4284 9.87739V10.2727C78.4284 11.462 78.6429 12.3486 79.0719 12.9333C79.5009 13.518 80.1211 13.8099 80.9316 13.8099H80.9277ZM93.4359 12.5938C93.4359 12.1544 93.2551 11.8153 92.8935 11.5904C92.532 11.3656 91.9321 11.158 91.0944 10.9824C90.2567 10.8068 89.557 10.5836 88.996 10.3133C87.7661 9.71867 87.1511 8.85717 87.1511 7.7284C87.1511 6.78214 87.5498 5.99157 88.3473 5.35669C89.1448 4.72181 90.1585 4.40394 91.3876 4.40394C92.6981 4.40394 93.7576 4.72829 94.5655 5.37701C95.3734 6.02573 95.7764 6.8669 95.7764 7.90096H93.3135C93.3182 7.67741 93.2733 7.45559 93.1821 7.25145C93.0909 7.0473 92.9555 6.8659 92.7859 6.72029C92.4338 6.40631 91.9641 6.24457 91.3872 6.24457C90.8466 6.24457 90.4055 6.37431 90.0638 6.61953C89.9016 6.73087 89.7699 6.88097 89.6804 7.0562C89.591 7.23142 89.5468 7.42622 89.5518 7.62288C89.5518 8.0013 89.7105 8.29538 90.0284 8.50514C90.3462 8.71489 90.9885 8.92594 91.9542 9.13872C92.9199 9.3515 93.6789 9.60493 94.2299 9.89902C94.7809 10.1931 95.19 10.546 95.4564 10.9586C95.7228 11.3712 95.8569 11.8668 95.8569 12.4593C95.8569 13.4453 95.4482 14.2454 94.6304 14.8565C93.8126 15.4676 92.7417 15.7734 91.4171 15.7734C90.5184 15.7734 89.7174 15.6112 89.0146 15.2868C88.3119 14.9625 87.7604 14.517 87.3725 13.9488C86.9846 13.3805 86.7843 12.7694 86.7843 12.1142H89.1759C89.2097 12.6954 89.4294 13.1435 89.8346 13.457C90.2398 13.7706 90.7774 13.9327 91.4465 13.9327C92.0952 13.9327 92.5882 13.8095 92.9264 13.563C93.2646 13.3165 93.4333 12.9934 93.4333 12.5942L93.4359 12.5938ZM3.45767 18.3272L4.61066 21.3909L5.76106 18.3272H6.65888V22.3241H5.96692V21.0064L6.03611 19.244L4.85545 22.3241H4.35809L3.18089 19.2427L3.25008 21.0029V22.3207H2.55812V18.3272H3.45767ZM8.52633 20.8122C8.52633 20.5211 8.58385 20.2586 8.69932 20.0251C8.81479 19.7915 8.97611 19.6125 9.18543 19.4871C9.39475 19.3617 9.63391 19.2989 9.90464 19.2989C10.3056 19.2989 10.6312 19.4278 10.8803 19.686C11.1294 19.9442 11.2695 20.2863 11.2855 20.7127L11.2881 20.8693C11.2881 21.1621 11.2319 21.4237 11.1152 21.6542C10.9984 21.8847 10.8414 22.0634 10.6321 22.1896C10.4228 22.3159 10.1806 22.3791 9.90551 22.3791C9.486 22.3791 9.15083 22.2394 8.89913 21.9604C8.64742 21.6815 8.52157 21.3091 8.52157 20.8446V20.8122H8.52633ZM9.19365 20.8697C9.19365 21.1755 9.25679 21.4146 9.38307 21.5876C9.50936 21.7606 9.68494 21.8471 9.9107 21.8471C10.1365 21.8471 10.3112 21.7593 10.4362 21.5876C10.5611 21.4159 10.6243 21.1552 10.6243 20.8161C10.6243 20.5159 10.5594 20.2781 10.4305 20.1025C10.3017 19.9269 10.1265 19.843 9.90507 19.843C9.68754 19.843 9.51455 19.9295 9.3861 20.1025C9.25765 20.2755 9.19408 20.5337 9.19408 20.8775L9.19365 20.8697Z"
        fill="white"
      />
      <path
        d="M14.644 19.9588C14.5542 19.944 14.4633 19.9366 14.3724 19.9368C14.0666 19.9368 13.8607 20.0535 13.7548 20.2884V22.3197H13.0879V19.3495H13.7249L13.7414 19.6816C13.9027 19.4234 14.1263 19.2945 14.4117 19.2945C14.4922 19.2921 14.5723 19.3052 14.6478 19.333L14.6444 19.9588H14.644Z"
        fill="white"
      />
      <path
        d="M17.5585 22.375C17.1356 22.375 16.793 22.2418 16.5305 21.9754C16.268 21.709 16.1413 21.3544 16.1413 20.9115V20.825C16.1413 20.5283 16.1984 20.2637 16.313 20.0306C16.4276 19.7974 16.588 19.6154 16.7948 19.4856C17.0015 19.3559 17.2273 19.291 17.4867 19.291C17.8911 19.291 18.2038 19.4199 18.4239 19.6781C18.6441 19.9363 18.7548 20.3009 18.7548 20.7736V21.0426H16.8138C16.8337 21.2878 16.9159 21.482 17.0594 21.6247C17.203 21.7674 17.3838 21.8387 17.6013 21.8387C17.9071 21.8387 18.1558 21.7151 18.3482 21.4681L18.7081 21.8111C18.5891 21.9841 18.4304 22.1268 18.2315 22.2241C18.0231 22.324 17.7944 22.3742 17.5633 22.3707L17.5585 22.375ZM17.479 19.8303C17.296 19.8303 17.1481 19.8943 17.0357 20.0223C16.9232 20.1503 16.8514 20.3251 16.8203 20.5577H18.0918V20.5084C18.0771 20.2853 18.0183 20.1162 17.9132 20.0024C17.8081 19.8887 17.6641 19.8307 17.4794 19.8307L17.479 19.8303ZM25.9296 18.8789H24.6832V22.3158H23.9943V18.8789H22.7591V18.327H25.93V18.8871L25.9296 18.8789ZM28.2836 19.6694C28.3838 19.548 28.5102 19.4508 28.6533 19.3851C28.7965 19.3195 28.9526 19.2872 29.1101 19.2906C29.7432 19.2906 30.0645 19.6521 30.0736 20.3748V22.3158H29.4063V20.3999C29.4063 20.1949 29.3618 20.0539 29.2731 19.9648C29.1844 19.8757 29.0543 19.8372 28.8821 19.8372C28.6149 19.8372 28.4151 19.9562 28.2836 20.194V22.3162H27.6158V18.0995H28.2827V19.6694H28.2836ZM33.7588 22.3162C33.7294 22.26 33.7038 22.167 33.6818 22.0394C33.5825 22.1465 33.4617 22.2315 33.3274 22.2887C33.193 22.3459 33.0481 22.3742 32.902 22.3716C32.5993 22.3716 32.3606 22.2864 32.172 22.1121C32.0818 22.0337 32.0097 21.9366 31.9609 21.8276C31.912 21.7185 31.8876 21.6001 31.8892 21.4807C31.8892 21.1641 32.0068 20.921 32.2416 20.7519C32.4765 20.5828 32.8134 20.4981 33.2506 20.4981H33.6597V20.3034C33.6597 20.1499 33.6165 20.0267 33.5309 19.9341C33.4452 19.8416 33.3146 19.7957 33.1382 19.7957C32.9868 19.7957 32.8614 19.8338 32.7649 19.9095C32.6685 19.9851 32.6196 20.0825 32.6196 20.1992H31.9527C31.9539 20.0329 32.011 19.8719 32.1149 19.7421C32.223 19.6007 32.3744 19.4891 32.5561 19.4091C32.7377 19.3291 32.9453 19.288 33.178 19.288C33.5257 19.288 33.8029 19.3753 34.0096 19.5501C34.2163 19.7248 34.3227 19.9704 34.3279 20.287V21.6268C34.3279 21.8941 34.3655 22.1026 34.4404 22.2669V22.3136H33.7592L33.7588 22.3162ZM33.0257 21.8405C33.1559 21.8408 33.2839 21.8077 33.3977 21.7445C33.5144 21.6805 33.6009 21.5944 33.6597 21.4863V20.9219H33.2999C33.0534 20.9219 32.8674 20.9651 32.7377 21.0508C32.6079 21.1364 32.5509 21.2584 32.5509 21.4158C32.5509 21.5438 32.5932 21.6459 32.6784 21.722C32.7636 21.7981 32.8782 21.8362 33.021 21.8362L33.0257 21.8405ZM36.8817 19.3459L36.9007 19.6889C37.1204 19.4234 37.4085 19.291 37.7657 19.291C38.3841 19.291 38.699 19.6456 38.7102 20.3536V22.3171H38.0472V20.3925C38.0472 20.204 38.0066 20.0647 37.9249 19.9739C37.8431 19.8831 37.7103 19.8381 37.5257 19.8381C37.2567 19.8381 37.0564 19.9592 36.9202 20.2031V22.3171H36.2533V19.3468H36.8817V19.3459ZM44.6317 20.2131L45.5512 18.3188H46.3197L44.9799 20.8445V22.3158H44.2827V20.8484L42.9403 18.3227H43.7119L44.6317 20.217V20.2131ZM47.6223 20.8038C47.6223 20.5128 47.6799 20.2503 47.7953 20.0167C47.9108 19.7832 48.0721 19.6041 48.2814 19.4787C48.4908 19.3533 48.7299 19.2906 49.0007 19.2906C49.4016 19.2906 49.7272 19.4195 49.9763 19.6777C50.2254 19.9358 50.3656 20.2779 50.3816 20.7044L50.3841 20.8609C50.3841 21.1537 50.3279 21.4154 50.2112 21.6459C50.0944 21.8764 49.9374 22.055 49.7281 22.1813C49.5188 22.3076 49.2766 22.3707 49.0015 22.3707C48.582 22.3707 48.2468 22.231 47.9951 21.9521C47.7434 21.6731 47.6176 21.3007 47.6176 20.8363V20.8038H47.6223ZM48.2892 20.8613C48.2892 21.1671 48.3524 21.4063 48.4786 21.5793C48.6049 21.7523 48.7805 21.8387 49.0063 21.8387C49.232 21.8387 49.4067 21.751 49.5317 21.5793C49.6567 21.4076 49.7199 21.1468 49.7199 20.8077C49.7199 20.5076 49.655 20.2697 49.5261 20.0941C49.3972 19.9185 49.2221 19.8346 49.0007 19.8346C48.7831 19.8346 48.6101 19.9211 48.4817 20.0941C48.3532 20.2671 48.2896 20.5253 48.2896 20.8691L48.2892 20.8613ZM53.985 22.0247C53.7891 22.2552 53.511 22.3707 53.1503 22.3707C52.8281 22.3707 52.5881 22.2764 52.4151 22.0879C52.2421 21.8993 52.1664 21.6268 52.1664 21.2696V19.3451H52.8333V21.261C52.8333 21.6381 52.9898 21.8266 53.3025 21.8266C53.6269 21.8266 53.8453 21.7099 53.9586 21.4781V19.3451H54.6255V22.3153H53.9966L53.9811 22.0243L53.985 22.0247Z"
        fill="white"
      />
      <path
        d="M58.101 19.9588C58.0112 19.944 57.9204 19.9366 57.8294 19.9368C57.5236 19.9368 57.3178 20.0535 57.2118 20.2884V22.3197H56.5449V19.3495H57.182L57.1984 19.6816C57.3597 19.4234 57.5833 19.2945 57.8687 19.2945C57.9492 19.2921 58.0294 19.3052 58.1049 19.333L58.1014 19.9588H58.101Z"
        fill="white"
      />
      <path
        d="M65.1855 18.8833H63.9391V22.3202H63.2501V18.8833H62.0145V18.3272H65.1855V18.8872V18.8833ZM67.539 19.6739C67.757 19.4213 68.032 19.2951 68.3607 19.2951C68.9943 19.2951 69.3152 19.6566 69.3252 20.3793V22.3202H68.6578V20.4044C68.6578 20.1994 68.6133 20.0584 68.5246 19.9693C68.436 19.8802 68.3054 19.8417 68.1337 19.8417C67.8664 19.8417 67.6666 19.9606 67.5351 20.1985V22.3207H66.8678V18.104H67.5351V19.6739H67.539ZM71.1148 20.8079C71.1148 20.5168 71.1723 20.2543 71.2878 20.0208C71.3939 19.7979 71.5629 19.6109 71.7739 19.4827C71.9823 19.353 72.2219 19.2946 72.4926 19.2946C72.894 19.2946 73.2192 19.4235 73.4687 19.6817C73.7183 19.9399 73.858 20.282 73.874 20.7084L73.8766 20.865C73.8766 21.1577 73.8203 21.4194 73.7036 21.6499C73.5868 21.8804 73.4298 22.059 73.2205 22.1853C73.0112 22.3116 72.769 22.3747 72.4939 22.3747C72.0744 22.3747 71.7393 22.235 71.4876 21.9561C71.2358 21.6771 71.1104 21.3048 71.1104 20.8403V20.8079H71.1148ZM71.7816 20.8654C71.7816 21.1711 71.8448 21.4103 71.9711 21.5833C72.0973 21.7563 72.2725 21.8428 72.4987 21.8428C72.7249 21.8428 72.8987 21.755 73.0242 21.5833C73.1496 21.4116 73.2127 21.1508 73.2127 20.8118C73.2127 20.5116 73.1478 20.2738 73.019 20.0982C72.8901 19.9226 72.7149 19.8387 72.4931 19.8387C72.2755 19.8387 72.1025 19.9252 71.9741 20.0982C71.8456 20.2712 71.7816 20.5293 71.7816 20.8732V20.8654ZM77.4765 22.0288C77.2806 22.2593 77.0025 22.3747 76.6418 22.3747C76.3196 22.3747 76.0796 22.2805 75.9066 22.0919C75.7336 21.9033 75.6584 21.6309 75.6584 21.2736V19.3491H76.3253V21.265C76.3253 21.6421 76.4818 21.8307 76.7945 21.8307C77.1189 21.8307 77.3373 21.7139 77.451 21.4821V19.3491H78.1183V22.3194H77.4895L77.4722 22.0283L77.4765 22.0288ZM79.9218 20.8178C79.9218 20.3568 80.0299 19.9883 80.247 19.7128C80.4641 19.4373 80.7517 19.2998 81.1107 19.2998C81.4489 19.2998 81.7153 19.4179 81.9094 19.6544L81.9397 19.3552H82.5452V22.2355C82.5452 22.6247 82.4241 22.9326 82.1819 23.158C81.9397 23.3833 81.6123 23.4953 81.2002 23.4953C80.9803 23.495 80.7628 23.4487 80.5618 23.3595C80.3542 23.273 80.196 23.1506 80.0878 23.004L80.4035 22.6031C80.6085 22.8466 80.8611 22.9681 81.1612 22.9681C81.3827 22.9681 81.5574 22.9076 81.6859 22.7882C81.8143 22.6688 81.8774 22.4924 81.8774 22.2597V22.0595C81.6858 22.2735 81.4294 22.3808 81.1089 22.3808C80.7612 22.3808 80.4775 22.2424 80.2569 21.9665C80.0364 21.6906 79.927 21.3065 79.927 20.8182L79.9218 20.8178ZM80.5861 20.8753C80.5861 21.1781 80.6466 21.4081 80.7686 21.5794C80.8905 21.7507 81.0592 21.8363 81.2754 21.8363C81.3978 21.8419 81.5192 21.8123 81.6252 21.751C81.7312 21.6896 81.8174 21.5992 81.8735 21.4903V20.1842C81.7438 19.9593 81.5501 19.8469 81.281 19.8469C81.1805 19.8429 81.0807 19.8648 80.991 19.9105C80.9014 19.9562 80.8249 20.024 80.769 20.1077C80.647 20.282 80.5865 20.5376 80.5865 20.8762L80.5861 20.8753ZM85.1197 19.6774C85.3377 19.4248 85.6128 19.2985 85.9414 19.2985C86.575 19.2985 86.8959 19.6601 86.9059 20.3827V22.3237H86.2386V20.4078C86.2386 20.2028 86.194 20.0618 86.1054 19.9727C86.0167 19.8837 85.8861 19.8452 85.7144 19.8452C85.4471 19.8452 85.2473 19.9641 85.1158 20.202V22.3241H84.4524V18.1075H85.1197V19.6774ZM89.6564 18.6316V19.3539H90.181V19.8482H89.6564V21.5063C89.6564 21.6196 89.6794 21.7018 89.7239 21.752C89.7685 21.8021 89.8537 21.8272 89.9639 21.8272C90.0426 21.8272 90.121 21.8181 90.1975 21.8V22.3159C90.0545 22.3566 89.9067 22.3779 89.7581 22.3791C89.2456 22.3791 88.9896 22.0962 88.9896 21.5314V19.8447H88.5009V19.3504H88.9896V18.6282H89.6564V18.6316ZM93.592 21.5163C93.592 21.3973 93.5431 21.3069 93.445 21.2447C93.3468 21.1824 93.1842 21.1279 92.9576 21.0803C92.7309 21.0328 92.5411 20.9722 92.3893 20.8987C92.0563 20.7374 91.8902 20.5043 91.8902 20.1981C91.8902 19.942 91.9983 19.728 92.2137 19.5558C92.4291 19.3837 92.7046 19.2976 93.0371 19.2976C93.3918 19.2976 93.6789 19.3854 93.9021 19.5571C94.0069 19.6371 94.0913 19.7407 94.1484 19.8596C94.2054 19.9784 94.2335 20.1091 94.2303 20.2409H93.5635C93.5657 20.1802 93.554 20.1198 93.5292 20.0643C93.5045 20.0088 93.4674 19.9598 93.4207 19.9208C93.3213 19.8352 93.1989 19.7933 93.0415 19.7933C92.8953 19.7933 92.7759 19.827 92.6834 19.8949C92.6395 19.9251 92.6039 19.9657 92.5798 20.0132C92.5556 20.0606 92.5436 20.1133 92.545 20.1665C92.545 20.269 92.5882 20.3481 92.6747 20.4052C92.7612 20.4623 92.9342 20.519 93.1959 20.5769C93.4575 20.6349 93.6629 20.7032 93.8126 20.7828C93.9622 20.8624 94.0721 20.9579 94.1447 21.0699C94.2174 21.182 94.2528 21.3165 94.2528 21.4765C94.2553 21.6037 94.2261 21.7296 94.168 21.8428C94.1099 21.956 94.0246 22.053 93.9198 22.1252C93.6975 22.2904 93.4082 22.3734 93.0497 22.3734C92.8062 22.3734 92.5895 22.3293 92.3992 22.2415C92.2089 22.1537 92.0606 22.0331 91.9538 21.8791C91.8501 21.734 91.7946 21.5601 91.7951 21.3818H92.4429C92.4516 21.5392 92.5112 21.6603 92.6211 21.745C92.7309 21.8298 92.8806 21.8726 93.0536 21.8726C93.2292 21.8726 93.3628 21.8393 93.454 21.7732C93.5453 21.707 93.5911 21.6196 93.5911 21.5115L93.592 21.5163Z"
        fill="white"
      />
    </svg>

  )
}

const ChatbotWidget: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [inputText, setInputText] = useState('');

  //confirmation popup state
  const [showCloseConfirmation, setShowCloseConfirmation] = useState(false);
  const [chatStarted, setChatStarted] = useState(false);

  const [isConnecting, setIsConnecting] = useState(true);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const { sendMessage, clear } = useChatInteract(); // Add clear method here
  const { messages } = useChatMessages();
  const { askUser, actions } = useChatData();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1920);

  // Handle resize event
  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1920);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);


  useEffect(() => {
    // Set a timeout to handle initial connection state
    const timer = setTimeout(() => {
      setIsConnecting(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // Track when chat starts by monitoring messages and actions
  useEffect(() => {
    // Check if user has selected sales or job option
    const userMessages = messages.filter(msg => msg.name === 'user');
    const hasUserInteracted = userMessages.some(msg =>
      msg.output === 'Sales / Project Inquiry' ||
      msg.output === 'Job / Career Opportunity' ||
      msg.output === 'Project Inquiry' ||
      msg.output === 'career Opportunity'
    );

    if (hasUserInteracted && !chatStarted) {
      setChatStarted(true);
    }
  }, [messages, chatStarted]);


  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSend = () => {
    if (!inputText.trim()) return;
    sendMessage({
      name: 'user',
      type: 'user_message',
      output: inputText
    });
    setInputText('');
  };


  // Handle close button click
  const handleCloseClick = () => {
    if (chatStarted) {
      // Show confirmation popup if chat has started
      setShowCloseConfirmation(true);
    } else {
      // Close directly if chat hasn't started
      setIsOpen(false);
    }
  };


  const handleConfirmClose = (clearChat: boolean) => {
    if (clearChat) {
      clear();
      // Clear chat - this will trigger a new session
      setChatStarted(false);
      setInputText('');
      // Close the widget regardless of choice
      setIsOpen(false);
      setShowCloseConfirmation(false);
    }
    else {
      setIsOpen(false);
      // Just close the popup, keep chat and widget open
      setShowCloseConfirmation(false);
      // Widget stays open, chat stays as it is
    }
  };

  const handleClearConversation = () => {
    clear();
    setChatStarted(false);
    setInputText('');
    setShowDropdown(false);
  };


  // const handleActionClick = (action: any) => {
  //   // Mark chat as started when user clicks sales/job options
  //   if (action.label === 'Sales / Project Inquiry' || action.label === 'Job / Career Opportunity') {
  //     setChatStarted(true);
  //     // console.log('Chat started - user clicked:', action.label);
  //   }

  //   sendMessage({
  //     name: 'user',
  //     type: 'user_message',
  //     output: action.label
  //   });

  //   if (askUser?.callback) {
  //     askUser.callback(action);
  //   }
  // };

  // Replace your existing handleActionClick function with this:

  const handleActionClick = (action: any) => {
    if (action.label === 'Start New Conversation') {
      // Clear the session completely
      clear();

      setChatStarted(false);
      setInputText('');

      return;
    }

    // Mark chat as started when user clicks sales/job options
    if (action.label === 'Sales / Project Inquiry' || action.label === 'Job / Career Opportunity') {
      setChatStarted(true);
    }

    sendMessage({
      name: 'user',
      type: 'user_message',
      output: action.label
    });

    if (askUser?.callback) {
      askUser.callback(action);
    }
  };




  useEffect(() => {
    if (messages.length === 0 && !isConnecting) {
      setChatStarted(false);
      setInputText('');
    }
  }, [messages.length, isConnecting]);

  // Enhanced filtering to remove unwanted messages
  const shouldFilterContent = (content: string) => {
    if (!content || !content.trim()) return true;

    const filterPatterns = [
      // Selection confirmations
      /^\*\*Selected:\*\*\s+.+$/,
      /^Selected:\s+.+$/,
      /You selected:/i,
      /Got it! You selected:/i,

      // Error messages we want to hide
      /I'm not sure how to respond/i,
      /Please use the options provided/i,
      /Sorry, I didn't understand/i,

      // Acknowledgment messages we want to hide
      /Thanks! I've got that information/i,
      /Got it!/i,


      // Typing indicators
      /🤖\s*\*?typing/i,
      /💭/,

      // Empty or minimal content
      /^\.{1,3}$/,
      /^…$/,
      /^\s*$/ // whitespace only
    ];

    return filterPatterns.some(pattern => pattern.test(content.trim()));
  };


  const flatMessages = useMemo(() => {
    function flattenMessages(messages: any[]): any[] {
      return messages.reduce((acc: any[], message) => {
        acc.push(message);
        if (message.steps && message.steps.length > 0) {
          acc.push(...flattenMessages(message.steps));
        }
        return acc;
      }, []);
    }


    const flattened = flattenMessages(messages);



    const validMessages = flattened
      .filter(msg => {
        if (!msg.output && !msg.streaming) return false;
        return !shouldFilterContent(msg.output || '');
      })
      .sort((a, b) => {
        if (a.createdAt && b.createdAt) {
          return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
        }
        return 0;
      });

    return validMessages;
  }, [messages]);




  const renderMessages = () => {
    if (isConnecting) {
      return (
        <div className="message bot">
          <div className="message-content typing-indicator">
            <span>Connecting...</span>
          </div>
        </div>
      );
    }
    if (!flatMessages || flatMessages.length === 0) return [];

    const rendered: JSX.Element[] = [];

    // Check if we currently have active options to show
    const hasActiveOptions = askUser?.spec?.type === 'action' && actions?.length > 0;


    // Check if the active options include "Start New Conversation" button
    const hasRestartButton = actions?.some(action => action.label === 'Start New Conversation');

    // Filter out "Start New Conversation" from inline options
    const inlineActions = actions?.filter(action => action.label !== 'Start New Conversation') || [];
    const hasInlineOptions = inlineActions.length > 0;

    // Render messages in a clean conversation flow
    flatMessages.forEach((msg, index) => {
      const isUser = msg.name === 'user';
      const key = `${isUser ? 'user' : 'bot'}-${msg.id || index}`;
      const isLastBotMessage = !isUser && index === flatMessages.length - 1;

      rendered.push(
        <div key={key} className={`message ${isUser ? 'user' : 'bot'}`}>
          <div className="message-content">
            {/* Clean up content display */}
            {msg.output.replace(/^\*\*.*?\*\*\s*/, '').trim() || msg.output}

            {/* Show options inline for the last bot message if there are active options */}
            {!isUser && isLastBotMessage && hasInlineOptions && (
              <div className="inline-options">
                {inlineActions.length > 10 ? (
                  // Show dropdown for many options
                  <>
                    <div className="option-instruction">Please select an option:</div>
                    <select
                      className="inline-dropdown-select"
                      onChange={(e) => {
                        const selectedOption = inlineActions.find(a => a.label === e.target.value);
                        if (selectedOption) {
                          handleActionClick(selectedOption);
                        }
                      }}
                    >
                      <option value="">Select an option</option>
                      {inlineActions.map((action, i) => (
                        <option key={i} value={action.label}>
                          {action.label}
                        </option>
                      ))}
                    </select>
                  </>
                ) : (
                  // Show buttons for fewer options
                  <>
                    {inlineActions.length > 1 && (
                      <div className="option-instruction">Please select an option:</div>
                    )}
                    <div className="inline-option-buttons">
                      {inlineActions.map((action, i) => (
                        <button
                          key={`inline-action-${i}-${action.label}`}
                          className="inline-option-button"
                          onClick={() => handleActionClick(action)}
                        >
                          {action.label}
                        </button>
                      ))}
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      );
    });


    // Add the "Start New Conversation" button as a SEPARATE element outside message bubbles
    if (hasRestartButton) {
      const restartAction = actions.find(action => action.label === 'Start New Conversation');
      if (restartAction) {
        rendered.push(
          <div key="restart-button-container" className="restart-button-container">
            <button
              className="restart-conversation-button"
              onClick={() => handleActionClick(restartAction)}
            >
              {restartAction.label}
            </button>
          </div>
        );
      }
    }
    return rendered;
  };

  const shouldShowInput = () => {
    // Always show input
    return true;
  };

  const isInputDisabled = () => {
    const hasActionButtons = askUser?.spec?.type === 'action' && actions?.length > 0;
    return hasActionButtons;
  };

  const getInputPlaceholder = () => {
    if (askUser?.spec?.type === 'text') {
      return "Type your answer...";
    }
    if (askUser?.spec?.type === 'action') {
      return "Please select from the options above...";
    }
    return "Type your message...";
  };

  return (
    <div style={{ position: 'relative' }}>
      <div className="chatbot-widget">
        <button
          className="chatbot-toggle chatbot-toggle-animation"
          onClick={() => setIsOpen(!isOpen)}
          aria-label={isOpen ? 'Close chat' : 'Open chat'}
        >
          {isOpen ? <X size={24} /> : <MessageSquare size={24} />}
        </button>

        {isOpen && (
          <div className="chatbot-window" style={{
            height: isExpanded ? "calc(100vh - 200px)" : "620px",
            transition: "height 0.3s ease"
          }}>
            <div className="chatbot-header">
              <WebethicsLogo />
              <div className="chatbot-header-content">

                {isLargeScreen && (<button onClick={() => setIsExpanded(!isExpanded)} className='dropdown-trigger'>
                  {isExpanded ? <CollapseIcon />  : <ExpandIcon />}
                </button>)}

                <div className="header-dropdown" ref={dropdownRef}>

                  <button
                    className="dropdown-trigger"
                    onClick={() => setShowDropdown(!showDropdown)}
                    aria-label="More options"
                  >
                    <MoreVertical size={20} />
                  </button>

                  {showDropdown && (
                    <div className="dropdown-menu">
                      <button
                        className="dropdown-item"
                        onClick={handleClearConversation}
                      >
                        Clear Conversation
                      </button>
                    </div>
                  )}
                </div>
              </div>

            </div>

            <div className="chatbot-messages">
              {renderMessages()}
              <div ref={messagesEndRef} />
            </div>

            {shouldShowInput() && (
              <div className={`chatbot-input ${isInputDisabled() ? 'disabled' : ''}`}>
                <textarea
                  value={inputText}
                  onChange={(e) => {
                    setInputText(e.target.value);

                    const lineHeight = 24; // match your textarea CSS line-height
                    const target = e.target;

                    // Reset height to calculate actual content height
                    target.style.height = 'auto';

                    const currentRows = Math.ceil(target.scrollHeight / lineHeight);

                    if (currentRows <= 3) {
                      target.rows = currentRows;
                      target.style.height = 'auto'; // Let it resize naturally
                    } else {
                      target.rows = 3;
                      target.style.height = `${3 * lineHeight}px`; // Fixed height for 3 rows
                      // Don't auto-scroll to bottom - let user control scroll position
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey && !isInputDisabled()) {
                      e.preventDefault();
                      handleSend();
                    }
                  }}
                  placeholder={getInputPlaceholder()}
                  className="input-field resize-none"
                  disabled={isInputDisabled()}
                  rows={1}
                  style={{ minHeight: '24px', maxHeight: '72px' }} // 1 row min, 3 rows max
                />
                <button
                  onClick={handleSend}
                  disabled={!inputText.trim() || isInputDisabled()}
                  aria-label="Send message"
                  className="send-button"
                >
                  <SendHorizonal size={24} color={!inputText.trim() || isInputDisabled() ? '#9e9e9e' : '#4629F2'} />
                </button>
              </div>
            )}

            {/* Confirmation Popup
            <ConfirmationPopup
              isOpen={showCloseConfirmation}
              onConfirm={handleConfirmClose}
              title="End Conversation?"
              message="Are you sure you want to end this conversation? Once ended, you won’t be able to continue where you left off."
              confirmText="Yes, End Conversation"
              cancelText="Just Close"

            /> */}
          </div>
        )}

      </div>
    </div>
  );
};

export default ChatbotWidget;




